import { Injectable } from '@angular/core';
import { Field } from 'models/custom-fields/field.model';
import { FieldType } from 'models/custom-fields/filed-type.model';
import { CreateField } from 'models/custom-fields/create-field.model';
import { SaveFieldValue } from 'models/custom-fields/save-field-value.model';
import { GetField } from 'models/custom-fields/get-field.model';
import { ApiClientService } from './common/api-client.service';
import { Observable } from 'rxjs';
import { ManageField } from '../models/custom-fields/manage-field.model';
import { Manage } from '../models/manage-mga.model';

@Injectable({
  providedIn: 'root'
})
export class CustomFieldService {

  constructor(
    private apiClient: ApiClientService) { }

  createField(model: CreateField): Observable<number> {
    return this.apiClient.post(`api/customfields/createField`, model, null, true);
  }

  getFieldTypes(): Observable<FieldType[]> {
    return this.apiClient.get(`api/customfields/getFieldTypes`, null, null, false);
  }

  getFields(model: GetField): Observable<Field[]> {
    return this.apiClient.get(`api/customfields/getFields`, null, model);
  }

  saveFieldValue(model: SaveFieldValue): Observable<any> {
    return this.apiClient.post(`api/customfields/saveFieldValue`, model, null, true);

  }

  getManageFields(model: GetField): Observable<ManageField[]> {
    return this.apiClient.get(`api/customfields/getManageFields`, null, model, false);
  }

  archiveField(model: any): Observable<void> {

    return this.apiClient.post(
      'api/customfields/archiveField',
      model,
      null,
      false);

  }

  getFieldById(fieldId: number): Observable<CreateField> {

    return this.apiClient.get(
      'api/customfields/getFieldById',
      null,
      {
        fieldId: fieldId
      });

  }

  updateField(model: CreateField): Observable<void> {

    return this.apiClient.post(
      'api/customfields/updateField',
      model,
      null,
      true);

  }

  updateFieldOrdinalPosition(model: ManageField[]): Observable<void> {

    return this.apiClient.post(
      'api/customfields/updateFieldOrdinalPosition',
      model,
      null,
      false);
  }
}
